import { createDraftSafeSelector, Reducer, SliceCaseReducers } from "@reduxjs/toolkit";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { Station } from "./queryStations";
import { AsyncEntityState } from "../../../Store/Thunks/asyncEntityStateUtil";
import { fetchStationByIdsThunk } from "../../../Store/Thunks/stationById";
import { RootState } from "../../../Store";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { entityByIdWithStatusHookFactory } from "../../../Store/Entities/entityByIdWithStatusHookFactory";
import { maxRowsAndCols } from "../SectionsCalls/locationSlice";


// Explicit typing is required
const { reducer, actions, entityAdapter, getSelectors } = createAsyncEntitySlice<Station, number, SliceCaseReducers<AsyncEntityState<Station, number>>, Station>({
  name: "station",
  reducers: {
  },
  fetchByIdsThunk: fetchStationByIdsThunk,
  selectId: (station) => station.station_id
})

export const stationReducer = reducer as Reducer<AsyncEntityState<Station, number>>;

const selectState = (state: RootState) => state.graphQlData.stations;

const { addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, updateOne, updateMany, clearPendingIds, addPendingId, addLoadingIds } = actions;
export const { selectById: selectStationById, selectAll: SelectAllStations } = entityAdapter.getSelectors(selectState);
export const updateManyStations = updateMany;

const stationFetcher = new EnqueueFetcher(fetchStationByIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

const selectLoadingIds = getSelectors(selectState).selectLoadingIds;
export const dispatchFetchStation = stationFetcher.enqueueFetchById;
export const dispatchManyFetchStation = stationFetcher.enqueueFetchByIds;
export const useStationById = entityByIdWithStatusHookFactory(dispatchFetchStation, selectStationById, selectLoadingIds)

export const selectStationByLocationId = createDraftSafeSelector(SelectAllStations, (_, locationId: number) => locationId, (stations: Station[], locationId: number) => stations.filter((station) => station.locationId === locationId));

export const selectStationMaxGridSpans = createDraftSafeSelector(
  [selectStationByLocationId, (_, stationId: number) => stationId],
  (stationForLocation, _stationId) => {
    if (!stationForLocation.length) {
      return { rows: 0, cols: 0 }
    }

    return stationForLocation.reduce(
      maxRowsAndCols,
      { rows: 0, cols: 0 })
  }
);
